import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetExaminationState } from "../../reduxStore/reducers/examinationReducersHelper";
import styles from "./examinationReadyScreen.module.scss";

const ExaminationReadyScreen = ({ examination, onStartExamination, onGoBack, disabled = false }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleGoBack = () => {
        if (onGoBack) {
            // Use the provided onGoBack callback (preferred)
            onGoBack();
        } else {
            // Fallback: Clear state and navigate
            // This prevents SATFullTestSelectorBox useEffect from triggering redirect
            dispatch(resetExaminationState());
            navigate("/user-sat-practice", { replace: true });
        }
    };

    const testStructure = [
        {
            part: "Reading and Writing",
            sections: [
                { name: "Module 1", questions: 27, time: 32 },
                { name: "Module 2", questions: 27, time: 32 }
            ]
        },
        {
            part: "Math",
            sections: [
                { name: "Module 1", questions: 22, time: 35 },
                { name: "Module 2", questions: 22, time: 35 }
            ]
        }
    ];

    // Calculate total time and questions
    const totalTime = testStructure.reduce((acc, part) =>
        acc + part.sections.reduce((secAcc, section) => secAcc + section.time, 0), 0
    );
    const totalQuestions = testStructure.reduce((acc, part) =>
        acc + part.sections.reduce((secAcc, section) => secAcc + section.questions, 0), 0
    );

    return (
        <div className={styles.readyToStartContainer}>
            <div className={styles.readyToStartContent}>
                <div className={styles.readyToStartHeader}>
                    <h1 className={styles.readyTitle}>Are you ready to start?</h1>
                    {disabled && (
                        <p className={styles.disabledMessage}>
                            ⚠️ Cannot start due to session error. Please try refreshing or going back.
                        </p>
                    )}
                </div>

                <div className={styles.testInfoContainer}>
                    <div className={styles.testOverview}>
                        <div className={styles.overviewItem}>
                            <span className={styles.overviewLabel}>Total Questions</span>
                            <span className={styles.overviewValue}>{totalQuestions}</span>
                        </div>
                        <div className={styles.overviewDivider}></div>
                        <div className={styles.overviewItem}>
                            <span className={styles.overviewLabel}>Total Time</span>
                            <span className={styles.overviewValue}>{totalTime} min</span>
                        </div>
                    </div>

                    <div className={styles.testStructure}>
                        {testStructure.map((part, partIndex) => (
                            <div key={partIndex} className={styles.partContainer}>
                                <h3 className={styles.partTitle}>{part.part}</h3>
                                <div className={styles.sectionsGrid}>
                                    {part.sections.map((section, sectionIndex) => (
                                        <div key={sectionIndex} className={styles.sectionCard}>
                                            <div className={styles.sectionName}>{section.name}</div>
                                            <div className={styles.sectionDetails}>
                                                <span>{section.questions} questions</span>
                                                <span className={styles.sectionDot}>•</span>
                                                <span>{section.time} min</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.buttonContainer}>
                    <button
                        className={styles.goBackButton}
                        onClick={handleGoBack}
                    >
                        <span className={styles.goBackButtonText}>← Go Back</span>
                    </button>

                    <button
                        className={`${styles.startButton} ${disabled ? styles.disabledButton : ''}`}
                        onClick={disabled ? undefined : onStartExamination}
                        disabled={disabled}
                    >
                        <span className={styles.startButtonText}>
                            {disabled ? 'Unavailable' : 'Start'}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExaminationReadyScreen;